module.exports = __webpack_public_path__ + "img/confernote_04.2e33c0fb.png";